<template>
    <div class="settings">
        <header> الإعدادات </header>

        <div class="container">
            <div class="lbls">
                <p> الألوان </p>
                
                <!-- darkmode -->
                <!-- <label style="display:none;">
                    <span>
                        <i style="color:#566fdc;" class="fas fa-moon"></i>
                        <span> الوضع الليلي </span>
                    </span>
                    <input id="nightCbx" type="checkbox" v-model="nightToggler">
                </label> -->
                <!-- theme -->
                <label @click="themeShowing()">
                    <!-- onclick="$('.themeColor').fadeIn(300);document.querySelector('.themeColor').style.display = 'flex';"> -->
                    <span>
                        <i style="color: #fcc45cdc;" class="fas fa-palette"></i>
                        <span> تغيير الوان الثيمة </span>
                    </span>
                    <span class="icon"><i class="fas fa-angle-left"></i></span>
                </label>
                <p> الوقت </p>
                <label @change="clocksystem()">
                    <span>
                        <i style="color: #566fdc;" class="fas fa-clock"></i>
                        <span> نظام 12 ساعة </span> 
                    </span>
                    <!-- {{ this.$store.state.hsys }} -->
                    <input id="hsyst" v-model="hsys" type="checkbox">
                    <!-- <small class="info-option">يفضل إعادة التشغيل</small> -->
                </label>


                <label @click="resetShowing()">
                    <span > <!-- #79a1cbdc -->
                        <i style="color: #cb79c0dc" class="fas fa-map-marked-alt"></i>
                        <!-- <i style="color: #79cb79dc" class="fas fa-map-marked-alt"></i> -->
                        <span> المنطقة الزمنية </span>
                    </span>
                    <span class="icon"><i class="fas fa-angle-left"></i></span>
                </label>

                <p> معلومات </p>
                <label @click="contactShowing()">
                    <span>
                        <i style="color: #e77f7fdc" class="fas fa-envelope"></i>
                        <span> تواصلوا معنا </span>
                    </span>
                    <span class="icon"><i class="fas fa-angle-left"></i></span>
                </label>

                <label @click="shareShowing()">
                    <span>
                        <i style="color: #e7a87edc" class="fa fa-share-alt"></i>
                        <span> مشاركة </span>
                    </span>
                    <!-- <i class="fa fa-share-alt"></i> -->
                </label>

                <label @click="aboutShowing()">
                    <span>
                        <i style="color: #b6c1cadc" class="fas fa-info-circle"></i>
                        <span> حول </span>
                    </span>
                    <span class="icon"><i class="fas fa-angle-left"></i></span>
                </label>


                <br><br><br>
                <!-- <label onclick="$('.change_Languages').fadeIn(300);document.querySelector('.change_Languages').style.display = 'flex';">
                        <span>
                            <i style="color: #6798c0dc" class="fas fa-globe"></i>
                            <span> اللغة </span>
                        </span>
                        <span class="icon"><i class="fas fa-angle-left"></i></span>
                    </label> -->
            </div>
        </div>
        <br>
        <!-- layers -->
        <!-- contact us -->
        <transition type="transition" mode="out-in" name="sliderr" appear>
            <contact-layer v-if="contactShow" @closeContact="contactShow = $event"></contact-layer>
        </transition>
        <!-- Share -->
        <transition type="transition" mode="out-in" name="sliderr" appear>
            <share-layer v-if="shareShow" @closeShare="shareShow = $event"></share-layer>
        </transition>
        <!-- aboutUs -->
        <transition type="transition" mode="out-in" name="sliderr" appear>
            <about-layer v-if="aboutShow" @closeAbout="aboutShow = $event"></about-layer>
        </transition>
        <!-- theme color -->
        <transition type="transition" mode="out-in" name="sliderr" appear>
            <theme-layer v-if="themeShow" 
            @closeTheme="themeShow = $event" 
            @themeMode="themeModeToggler.push($event)"></theme-layer>
        </transition>
        <!-- reset -->
        <transition type="transition" mode="out-in" name="sliderr" appear>
            <resettz-layer v-if="resetTimeZone" @closeReset="resetTimeZone = $event"></resettz-layer>
        </transition>


        <div class="thx" title="notify"></div>
        <!-- version p -->
        <p style="text-align: center;opacity: 0.4;"> الإصدار 1.0.1 </p>
    </div>
</template>

<script>
import contactUs from "./settings-cmp/contact-cmp.vue"
import aboutUs from "./settings-cmp/about-cmp.vue"
import shareUs from "./settings-cmp/share-cmp.vue"
import themeUs from "./settings-cmp/theme-cmp.vue"
import resetTZ from "./settings-cmp/resetTimeZone.vue"

export default {
    name: "settingsActive",
    data() {
        return {

            hsys: window.localStorage.getItem("hoursSystem") != "true" ? false: true,
            //hsys: window.localStorage.getItem("hoursSystem") != undefined && window.localStorage.getItem("hoursSystem") != "false" ? window.localStorage.getItem("hoursSystem") : false,
            // hsys: window.localStorage.getItem("hoursSystem") != undefined ? window.localStorage.getItem("hoursSystem") : 0,
            themeShow: false,
            contactShow: false,
            shareShow: false,
            aboutShow: false,
            resetTimeZone: false,
        }
    },
    methods: {
        /**
         * togglerr() {
            var link = document.createElement("link");
            link.setAttribute("href", "css/darkmode.css");
            link.setAttribute("rel", "stylesheet");
            //var linkC = link.setAttribute("class", "darkmodeLink");

            var theme = document.querySelector("meta[name='theme-color']").getAttribute("content");
            if (this.ok) {
                document.head.appendChild(link);
                window.localStorage.setItem("darkmode", true);
                document.documentElement.style.setProperty("--mainColor", theme.slice(0, 7) + "77");

                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            }
            else {
                document.head.removeChild(document.head.querySelector(".darkmodeLink"));
                window.localStorage.setItem("darkmode", false);
                document.documentElement.style.setProperty("--mainColor", theme.slice(0, 7) + "ff");

                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));

            }
        },
        */
        themeShowing() { this.themeShow = !this.themeShow; },
        contactShowing() { this.contactShow = !this.contactShow; },
        shareShowing() { this.shareShow = !this.shareShow; },
        aboutShowing() { this.aboutShow = !this.aboutShow; },
        resetShowing() { this.resetTimeZone = !this.resetTimeZone; },
        clocksystem() {
            this.$store.state.hsys = !this.$store.state.hsys;
            this.hsys = this.$store.state.hsys;
            window.localStorage.setItem("hoursSystem", this.$store.state.hsys);
        }
    },
    components: {
        contactLayer: contactUs,
        aboutLayer: aboutUs,
        shareLayer: shareUs,
        themeLayer: themeUs,
        resettzLayer: resetTZ,

    }
}

// var link = document.createElement("link");
//     link.setAttribute("href", "css/darkmode.css");
//     link.setAttribute("rel", "stylesheet");
// var linkC = link.setAttribute("class", "darkmodeLink");

// dark mode toggler
// nightModeCbx.onclick = function() {
//     var theme = document.querySelector("meta[name='theme-color']").getAttribute("content");
//     if(nightModeCbx.checked) {
//         document.head.appendChild(link);
//         window.localStorage.setItem("darkmode", true);
//         document.documentElement.style.setProperty("--mainColor", theme.slice(0,7) + "77");     
        
//         window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
//         window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
//         window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
//     }
//     else {
//         document.head.removeChild(document.head.querySelector(".darkmodeLink"));
//         window.localStorage.setItem("darkmode", false);
//         document.documentElement.style.setProperty("--mainColor", theme.slice(0,7) + "ff");

//         window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
//         window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
//         window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
//     }
// }
</script>




<style scoped>

.sliderr-enter-active, 
.sliderr-leave-active {
  transition: all .5s ease;
}
.sliderr-enter, 
.sliderr-leave-to {
  opacity: 0;
  transform: translateY(-25px);
} 

.lbls label {position: relative;}
.lbls label:hover .info-option {
    opacity: 1;
    transition-delay: 0.5s;
}
/* .info-option {
    position: absolute;
    bottom: -5px;
    left: -10px;
    background: var(--mainColor);
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    transform: scale(0.8);
} */

</style>